import { render } from "./Certificate.vue?vue&type=template&id=3b7ebd00&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=3b7ebd00&scoped=true&lang=css"
import "./Certificate.vue?vue&type=style&index=1&id=3b7ebd00&lang=css"

import exportComponent from "/opt/build/repo/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7ebd00"]])

export default __exports__